import React from 'react';
import { Badge } from 'antd';

/**
 * NEWバッジコンポーネント
 * サイドバーメニューなどで新機能を示すために使用
 */
const NewBadge = ({
  show = true,
  children,
  offset = [6, 0],
  size = 'small',
  style = {},
}) => {
  if (!show) {
    return children;
  }

  return (
    <Badge
      dot
      offset={offset}
      size={size}
      style={{
        backgroundColor: '#ff4d4f',
        boxShadow: '0 0 0 1px #fff',
        ...style,
      }}
    >
      {children}
    </Badge>
  );
};

/**
 * NEW テキストバッジ（より目立つバージョン）
 */
export const NewTextBadge = ({
  show = true,
  style = {},
}) => {
  if (!show) return null;

  return (
    <span
      style={{
        display: 'inline-block',
        backgroundColor: '#ff4d4f',
        color: '#fff',
        fontSize: 10,
        fontWeight: 'bold',
        padding: '1px 4px',
        borderRadius: 4,
        marginLeft: 6,
        lineHeight: 1.2,
        verticalAlign: 'middle',
        ...style,
      }}
    >
      NEW
    </span>
  );
};

export default NewBadge;
